// extracted by mini-css-extract-plugin
export default {"horizontalSeparator":"IpcProfiling_horizontalSeparator__Zmu10","grid":"IpcProfiling_grid__nUi34"};